<div class="ps-container" #container>
    <div>
        <div class="ps-label {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}" >
            {{label}}
        </div>
    </div>

    <ng-container *ngIf="!isIEMode; else radiosTemplate" >
        <button type="button" class="invisible-button" (keydown)="onKeyDown($event)" (blur)="onBlur()">
            <ng-container
                *ngTemplateOutlet="radiosTemplate">
            </ng-container>
        </button>
    </ng-container>

</div>

<ng-template #radiosTemplate>
    <div class="radio-container" *ngFor="let radio of radios" (click)="radioClicked(radio)"
         [ngClass]="getFaName(radio.internalName)">

        <!--            <span class="focus-indicator" *ngIf="radio.selected"></span>-->
        <bd-fa-button [name]="getFaName(radio.internalName)"></bd-fa-button>
        <bd-radio class="branch" [radio]="radio" [group]="group"></bd-radio>
    </div>


</ng-template>
